import router from '@/router';

export default {
  namespaced: true,
  actions: {
    goToGame({ commit }, { gameId, currentSeasonId, hideHeader, page = false, isCup = false }) {
      commit('setIsSectionLoading', true, { root: true });
      setTimeout(() => {
        const query = {
          currentSeason: currentSeasonId,
        };
        if (page) {
          query.pages = 'calendar-gs-2';
        }
        if (hideHeader) {
          query.is_iframe = true;
        }
        if (isCup) {
          query.isCup = true;
        }
        router.push({
          name: 'matchAnalysis',
          params: { gameId },
          query,
        });
      }, 10);
    },
  },
};
